module.exports = __webpack_public_path__ + "img/caas2-m@2.8e036c52.jpg";